<template>
  <vs-button
      size="small"
      :id="getFieldID(schema)"
      @click="onClick"
      :name="schema.inputName"
      :disabled="disabled"
      :class="classes"
      :color="schema.buttonColor || ''"
      v-attributes="'input'"
  >
    <vue-element-loading :active="schema.loading === true"></vue-element-loading>
    {{ schema.buttonText }}
  </vs-button>
</template>

<script>
import abstractField from 'vue-form-generator/src/fields/abstractField';

export default {
  mixins: [abstractField],
  computed: {
    classes() {
      return ['form-pill-button', this.schema.fieldClasses];
    },
  },
  methods: {
    onClick($event) {
      if (this.schema.onClick) {
        this.schema.onClick(this.model, this.schema, $event);
      }
    }
  }
};
</script>

<style lang="scss">
.form-pill-button {
  display: flex !important;
  padding: 5.6px 10.74px !important;
  border-radius: 15px !important;

  &.pointer {
    cursor: pointer;
    transition: all .4s ease-out;

    &:hover {
      filter: brightness(0.9);
    }
  }

  span {
    font-size: 11px !important;
  }
}
</style>
